import React from 'react';

export default function IconNL() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#FF4B55"
                d="M32 7.506H0V1.069C0 .764.247.517.55.517h30.897c.305 0 .552.247.552.552v6.437Z"
            />
            <path
                fill="#41479B"
                d="M31.448 21.483H.55A.552.552 0 0 1 0 20.93v-6.437h32v6.437a.552.552 0 0 1-.552.552Z"
            />
            <path fill="#F5F5F5" d="M32 7.506H0v6.988h32V7.506Z" />
        </svg>
    );
}
